import { ReactComponent as OpenIcon } from '../../../assets/Icons/caret/Caret-Right.svg';
import { ReactComponent as CloseIcon } from '../../../assets/Icons/caret/Caret-Down.svg';
import { useState, MouseEvent } from 'react';

export default function ExpandJson({
    json,
}: {
    json: any
}) {
    const [ isOpen, setIsOpen ] = useState(true);

    const toggleOpen = (e:MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setIsOpen(!isOpen);
    }

    return (
        <div className='flex justify-start items-start gap-2 w-full'>
            <button 
                className='text-disable hover:text-primary transition-all w-[14px] shrink-0' 
                onClick={toggleOpen}
            >
                {isOpen ? <CloseIcon/> : <OpenIcon/>}
            </button>
            <pre className={`p-4 rounded-lg border border-outline whitespace-pre-wrap ${isOpen && 'grow'}`}>
                {isOpen ? (
                    <>
                    {typeof json === 'string' ? json : JSON.stringify(json, null, 2)}
                    </>
                ) : (
                    `{...}`
                )}
            </pre>
        </div>
    )
}